export function slugify(input: string): string {
  return input
    .trim()
    .toLowerCase()
    .replace(/['']/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

/** Opaque public URL segment for news (no user input). */
export function randomNewsSlug(): string {
  return `news-${crypto.randomUUID().replace(/-/g, "").slice(0, 12)}`;
}

/**
 * URL segment: optional manual "Username / URL", else slug from source text,
 * else a short random id prefixed for uniqueness.
 */
export function resolveEntitySlug(
  manualUsernameUrl: string,
  sourceForAutoSlug: string,
  fallbackPrefix: string
): string {
  const manual = manualUsernameUrl.trim();
  if (manual) {
    const s = slugify(manual);
    if (s) return s;
  }
  const fromSource = slugify(sourceForAutoSlug);
  if (fromSource) return fromSource;
  return `${fallbackPrefix}-${crypto.randomUUID().replace(/-/g, "").slice(0, 12)}`;
}
